module.exports = __webpack_public_path__ + "img/faq-left-4x.2a67fef0.png";